import React from 'react';
import { useSelector } from 'react-redux';

import { useBankregnr } from '../../config';
import { getExternalUrlForSkadetype } from '../../landingsside/deep-link-handler';
import { AppState } from '../../reducers';
import { SideType, Utloggetside } from '../../utils/piwik-utils';
import { Error } from '../error/error';

enum PartnerBankregnr {
    Fana = '3411',
    More = '3910',
    Econa = '0820',
}

const isPartner = (bankregnr: string): boolean => {
    return Object.values<string>(PartnerBankregnr).includes(bankregnr);
};

export const InvalidSessionError = () => {
    const { skadetype } = useSelector((state: AppState) => state.skademelding);
    const sideDetail: Utloggetside = { type: SideType.Utloggetside, skademeldingstype: skadetype };
    const bankregnr = useBankregnr();

    if (isPartner(bankregnr)) {
        return (
            <>
                <div className="container__standard-width header-container">
                    <Error headerText="Noe gikk galt" bodyText="Du må være logget inn for å bruke denne tjenesten." />
                </div>
            </>
        );
    }
    return (
        <>
            <div className="container__standard-width header-container">
                <Error
                    headerText="Du er blitt logget ut"
                    bodyText="På grunn av inaktivitet har vi logget deg ut. Hvis du ønsker å fortsette utfyllingen av
                    skademeldingen nå, kan du logge inn på nytt."
                    errorButtonProps={{
                        buttonText: 'Logg inn',
                        buttonDataTrackId: 'error-button-logg-inn',
                        onButtonClick: () => window.location.replace(getExternalUrlForSkadetype(skadetype)),
                        sideDetail,
                    }}
                />
            </div>
        </>
    );
};
